import AuthService from '../../Admin/services/AuthService';
import WorkspaceSettings from '../../Admin/components/Settings/WorkspaceSettings';
import SuperAdminPlatformSettings from './SuperAdminPlatformSettings';

export default function SettingsPage() {
  const roleNum = parseInt(AuthService.getLoggedInRoleId(), 10);
  if (roleNum === 1) return <SuperAdminPlatformSettings />;
  return <WorkspaceSettings />;
}
